import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4be3cc30")

_pushScopeId("data-v-4be3cc30")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group alignC" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增配件", -1)
const _hoisted_4 = { class: "flex alignC" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_6 = { class: "flex flexC alignC" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = { class: "dialog-content" }
const _hoisted_9 = { class: "flex dialog-screen" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        class: "bg-red mar-r-18",
        onClick: _ctx.add
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "parts_name",
          label: "配件名称",
          "min-width": "380"
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "specification",
          label: "规格",
          "min-width": "100"
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "encoding",
          label: "编码",
          "min-width": "260"
        }),
        _createVNode(_component_el_table_column, {
          label: "数量",
          "min-width": "100",
          align: "center"
        }, {
          default: _withId((scope) => [
            _createVNode(_component_el_input, {
              modelValue: scope.row.number,
              "onUpdate:modelValue": ($event: any) => (scope.row.number = $event),
              type: "text",
              class: "mar-l-16",
              style: {"width":"80px"},
              onChange: ($event: any) => (_ctx.updateNumber(scope.row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "200"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                style: {"padding":"1px 21px","min-height":"28px"},
                class: "mar-r-16",
                onClick: ($event: any) => (_ctx.deleteParts(scope.row))
              }, {
                default: _withId(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_dialog, {
      center: "",
      title: "添加配件",
      modelValue: _ctx.dialog_show.parts,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialog_show.parts = $event)),
      width: 900
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_el_input, {
                style: {"width":"202px"},
                modelValue: _ctx.dialogSelect.search,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogSelect.search = $event)),
                placeholder: "配件名称/拼音首字母",
                clearable: "",
                class: "mar-r-18",
                "suffix-icon": "el-icon-search",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogSelectChange($event, 'search')))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_el_table, {
              data: _ctx.partsTable,
              stripe: "",
              style: {"width":"100%"},
              class: "table",
              onCurrentChange: _ctx.handleCurrentChange,
              onSelectionChange: _ctx.handleSelectionChange
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "onCurrentChange", "onSelectionChange"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})